import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController, PopoverController, Events } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { EventsProvider } from '../../providers/events/events';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoEventPopupDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-co-event-popup-details',
  templateUrl: 'co-event-popup-details.html',
})
export class CoEventPopupDetailsPage {

  currentEvent: any;
  searchTypes: any;
  clientKeyword: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public config: ConfigProvider, public viewCtrl: ViewController, public modalCtrl: ModalController, public popoverCtrl: PopoverController, private events: Events, private eventsProvider: EventsProvider, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.currentEvent = this.navParams.get('currentEvent');
    this.searchTypes = this.navParams.get('searchTypes');
    this.clientKeyword = this.navParams.get('clientKeyword');
    this.events.subscribe('updateAllEvents', async () => {
      this.currentEvent = await this.eventsProvider.checkInterestedEvents(this.currentEvent);
    });
  }

  ngOnInit() {
    // document.querySelector('.modal-wrapper').setAttribute('style', 'height: 450px;');
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
    this.events.unsubscribe('timeoutCalled');
  }
  hideModal() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    } else {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-event-popup-details/co-event-popup-details.ts